import { isObject } from '@frontend/utils';

import type { Init } from '../types';
import { getDoesBodyRequireModification } from './getDoesBodyRequireModification';

export const getBodyIsUnsupportedType = (body?: Init['body']): boolean =>
  getDoesBodyRequireModification(body) && !isObject(body);
